/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import { ContainerProps } from "../../service/interfaces/Components";

const InfiniteScrollContainer: React.FC<ContainerProps> = ({
  children,
  fetchMoreData,
  hasMore,
  isFetching,      
  height = "80vh",        
  className = "",
  style = {},
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    if (!containerRef.current || isFetching) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    // Trigger fetch when near the bottom
    if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore) {
      fetchMoreData();
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [isFetching, hasMore]);

  return (
    <div
      ref={containerRef}
      className={`flex flex-col ${className} min-w-[380px]`} 
      style={{
        height,
        overflow: "auto",  
        ...style,
      }}
    >
      <div className="flex-grow space-y-4">{children}</div>

      {/* Loading Indicator */}
      {isFetching && (
        <div className="flex justify-center py-4">
          <p className="text-gray-500">Loading more data...</p>
        </div>
      )}

      {/* No more data */}
      {!hasMore && (
        <div className="text-center py-4 text-gray-500">
          No more data to load
        </div>
      )}
    </div>
  );
};

export default InfiniteScrollContainer;
